import React from "react"
import style from './index.module.scss'
import Sidebar from "../Sidebar"

export default function Layout({ children }: any){
    // The sidebar is permanently collapsed (no expand/collapse control).
    return (
        <div className={style.layout}>
            <div className={`${style.layout__left} ${style.layout__leftCollapsed}`}>
                <Sidebar />
            </div>
            <div className={style.layout__right}>
                {children}
            </div>
        </div>
    )
}

